import * as Yup from 'yup';
import { validUSState } from 'common/helpers/yup-helpers';

Yup.addMethod(Yup.mixed, 'validUSState', validUSState);

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name or Company is required'),
  relationship: Yup.string().required('Relationship is required'),
  email: Yup.string()
    .email('please enter a valid email')
    .nullable()
    .when('relationship', {
      is: 'billToOther',
      then: (schema) => schema.required('Email is required for Bill To Other interested party'),
      otherwise: (schema) => schema.nullable()
    }),
  address: Yup.string().ensure().required('Address is required'),
  address2: Yup.string().nullable(),
  city: Yup.string().nullable().required('City is required'),
  state: Yup.string().ensure().validUSState('farm-interested-party.state').required('State is required'),
  zip: Yup.string().nullable().required('Zip is required'),
  associatedEntity: Yup.string().nullable()
});
